import React, { useState } from "react";
import "./emails.css";
import help from "../../../img/undraw_opened_re_i38e.svg";
import { Fade } from "react-awesome-reveal";
import { TextField, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import notify from "../../Notifcation";
import { SendEmailltouserDashboardAction } from "../../../redux/actions/ManageAdminAction";
import { useEffect } from "react";
import { ToastContainer } from "react-toastify";
import { Spinner } from "react-bootstrap";
const Emails = () => {
  const [Email, setEmail] = useState("");
  const [Messagee, setMessage] = useState("");
  const [Title, setTitle] = useState("");
  const [loading, setLoading] = useState(true);
  const [isPress, setIsPress] = useState(false);
  const dispatch = useDispatch();
  const handlesubmit = async (e) => {
    e.preventDefault();
    if (Title === "" || Messagee === "" || Email === "") {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    setIsPress(true);
    setLoading(true);
    await dispatch(
      SendEmailltouserDashboardAction({
        emailTo: Email,
        subject: Title,
        content: Messagee,
      })
    );
    setLoading(false);
    setIsPress(false);
    setMessage("");
    setTitle("");
    setEmail("");
  };
  const res = useSelector((state) => state.ManageAdminR.Email);
  useEffect(() => {
    if (loading === false) {
      if (res && res.data) {
        if (res.data.responseMessage === "Great, email sent successfully") {
          notify("تم أرسال الرسالة بنجاح", "success");
        }
      } else {
        notify("الرجاء حاول مرة اخرى", "error");
      }
    }
  }, [loading, res]);
  return (
    <>
      <div className="email">
        <div className="container rounded bg-white mt-5 mb-5">
          <div className="row">
            <h4 className="text-center">رسائل الإيميل</h4>
            <div className="col-md-6 border-right">
              <div className="p-3 py-5">
                <div className="d-flex justify-content-between align-items-center mb-3"></div>
                <div className="row mt-3">
                  <div className="col-md-12 de mb-2">
                    {" "}
                    <TextField
                      label={
                        <Typography
                          sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                          الإيميل
                          <span style={{ color: "red", fontSize: "19px" }}>
                            *
                          </span>
                        </Typography>
                      }
                      variant="outlined"
                      value={Email}
                      onChange={(e) => setEmail(e.target.value)}
                      type="email"
                    />
                  </div>
                  <div className="col-md-12 de mb-2">
                    {" "}
                    <TextField
                      label={
                        <Typography
                          sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                          عنوان الرسالة
                          <span style={{ color: "red", fontSize: "19px" }}>
                            *
                          </span>
                        </Typography>
                      }
                      variant="outlined"
                      value={Title}
                      onChange={(e) => setTitle(e.target.value)}
                      inputProps={{ maxLength: 120 }}
                      type="text"
                    />
                  </div>
                  <div className="col-md-12 de are mb-2">
                    {" "}
                    <TextField
                      multiline
                      label={
                        <Typography
                          sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                          الرسالة
                          <span style={{ color: "red", fontSize: "19px" }}>
                            *
                          </span>
                        </Typography>
                      }
                      variant="outlined"
                      value={Messagee}
                      onChange={(e) => setMessage(e.target.value)}
                      inputProps={{ maxLength: 120 }}
                    />
                  </div>
                </div>
                <div className="mt-5 text-center">
                  {isPress && loading ? (
                    <button className="buttonadd profile-button" type="button">
                      <Spinner animation="border" role="status"></Spinner>
                    </button>
                  ) : (
                    <button
                      className="buttonadd"
                      type="button"
                      onClick={handlesubmit}>
                      إرسال
                    </button>
                  )}
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <Fade direction="left">
                <div className="p-3 py-5">
                  <Fade direction="right">
                    <div className="d-flex flex-column align-items-center text-center p-3 py-5">
                      <img
                        className="mt-5"
                        width="150px"
                        src={help}
                        alt="avatar"
                      />
                    </div>
                  </Fade>
                </div>
              </Fade>
            </div>
          </div>
        </div>
        <ToastContainer autoClose={1200} />
      </div>
    </>
  );
};
export default Emails;
